import { TableRow, TableCell, IconButton, Tooltip, Link } from "@mui/material";
import { Bookmark, BookmarkBorder } from "@mui/icons-material";
import {
  parseAnchor,
  isLinkClicked,
  markLinkClicked,
} from "../../../../../utils/functions";
import { getStripedRowStyles } from "../../../utils/tableRowStyle";
import theme from "../../../../../theme";

// Constants
const TITLE_MAX_LENGTH = 85;
const TITLE_MIN_WIDTH = 200;
const TITLE_MAX_WIDTH = 470;

export const NewsTableRow = ({
  item,
  index,
  isBookmarked,
  clickedLinks,
  setClickedLinks,
  onToggleBookmark,
}) => {
  const parsedTitle = parseAnchor(item["Title"]);
  const newsId = String(item.news_id);
  // Whether this item is bookmarked (boolean)
  const itemIsBookmarked = isBookmarked(newsId);

  // Row background and border logic
  const getRowStyles = () =>
    getStripedRowStyles(index, { withBorder: true, startWithWhite: false });

  return (
    <TableRow sx={getRowStyles()}>
      {/* Bookmarks Column */}
      <TableCell sx={{ textAlign: "center" }}>
        <IconButton
          onClick={() => {
            onToggleBookmark(newsId);
          }}
          size="small"
          sx={{
            backgroundColor: "primary.white",
            color: itemIsBookmarked ? "primary.brandSecondary" : "primary.main",
            boxShadow: `4px 4px 12px ${theme.palette.secondary.lightBlack}70`,
            border: "none",

            "&:hover": itemIsBookmarked
              ? {
                  backgroundColor: "primary.main",
                  color: "primary.white",
                }
              : {
                  backgroundColor: "primary.white",
                  color: "primary.brandSecondary",
                },
          }}
        >
          {itemIsBookmarked ? <Bookmark /> : <BookmarkBorder />}
        </IconButton>
      </TableCell>

      {/* Section Column */}
      <TableCell>{item.Section || "-"}</TableCell>

      {/* Title Column */}
      <TableCell
        sx={{
          minWidth: TITLE_MIN_WIDTH,
          maxWidth: TITLE_MAX_WIDTH,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {parsedTitle ? (
          parsedTitle.text.length > TITLE_MAX_LENGTH ? (
            <Tooltip title={parsedTitle.text} arrow>
              <Link
                href={parsedTitle.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  markLinkClicked(
                    parsedTitle.href,
                    clickedLinks,
                    setClickedLinks,
                  )
                }
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  maxWidth: "100%",
                  fontWeight: 500,

                  color: isLinkClicked(parsedTitle.href, clickedLinks)
                    ? "secondary.berry"
                    : "secondary.tiffanyBlue",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {parsedTitle.text.slice(0, TITLE_MAX_LENGTH) + "..."}
              </Link>
            </Tooltip>
          ) : (
            <Link
              href={parsedTitle.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                markLinkClicked(parsedTitle.href, clickedLinks, setClickedLinks)
              }
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                maxWidth: "100%",
                fontWeight: 500,

                color: isLinkClicked(parsedTitle.href, clickedLinks)
                  ? "secondary.berry"
                  : "secondary.tiffanyBlue",
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              {parsedTitle.text}
            </Link>
          )
        ) : (
          "-"
        )}
      </TableCell>

      {/* Description Column */}
      <TableCell>{item.Description || "-"}</TableCell>

      {/* Published Column */}
      <TableCell sx={{ whiteSpace: "nowrap" }}>
        {item.Published?.split(" ")[0] || "-"}
      </TableCell>
    </TableRow>
  );
};
